<app-bottom-notification class="drive-bottom-notif"></app-bottom-notification>
<div
  [ngClass]="{ 'is-project-view': isProjectView, 'is-drive-view': !isProjectView }"
  class="webapp-page-container drive-container"
>
  @if (!isProjectView) {
    <div class="text-wrapper">
      <div class="pointer-cursor title-page" (click)="goBack(-1)">BuildEvo Storage Drive</div>
      <div class="flex items-center gap-2">
        @if (isPublicLinkAccessed && (sharedBy$ | async)) {
          <div class="shared-by font-weight-bold">
            <span class="text-navy-900">Share View By</span>
            <span class="text-navy-600">{{ sharedBy$ | async }}</span>
          </div>
        }
      </div>
    </div>
  }

  <ng-scrollbar
    class="std-scrollbar horizontal-scrollbar upload-drop-area"
    appUploadDrop
    appearance="compact"
    orientation="horizontal"
    (fileDropped)="onFilesDropped($event)"
    [supportFolderUpload]="true"
  >
    <div class="documents" [ngClass]="{ 'grid justify-normal': selectedView.value === DRIVE_VIEWS.WORD }">
      @if (selectedView.value === DRIVE_VIEWS.DEFAULT) {
        <div class="header">
          <div class="icon checkbox">
            <app-checkbox
              name="selectAllDocumentCheckBox"
              id="selectAllDocumentCheckBox"
              (click)="handleFilesSelection(allDocsCheckbox)"
              [(ngModel)]="allDocsCheckbox"
              [ngModelOptions]="{ standalone: true }"
              type="square"
            >
            </app-checkbox>
          </div>
          <app-floating-input
            #floatingInputComponent
            ngDefaultControl
            [disabled]="!currentFolder?.permissions?.[PERMISSION_LITERALS.CAN_MODIFY_CONTENT]"
            (keyup.enter)="addFolder()"
            (iconClick)="addFolder()"
            (focusin)="clearPlaceholder()"
            (focusout)="addPlaceholder()"
            iconClass="icon-add-block-square cursor-pointer text-blue-700 hover:brightness-110 text-[20px]"
            [formControl]="folderName"
            name="folderName"
            [placeholder]="folderNamePlaceholder"
          ></app-floating-input>
          <app-styled-options-list
            #allDriveOptionsList
            [listItems]="driveOptionsList"
            [disabledActionList]="
              driveOptionsList | uncommonPermissions: selectedFiles : isPublicLinkAccessed : currentFolder
            "
            [optionOverlayPositions]="driveHeaderOptionOverlayPositions"
            (selectedOption)="registerMultipleOptions($event)"
          >
            <div class="options cursor-pointer font-semibold text-sm text-blue-700 flex gap-2.5 px-5">
              <span class="select-none">Options</span>
              <span
                [ngClass]="{ 'rotate-180': allDriveOptionsList?.optionsListGeneralComponent?.show }"
                class="icon-rounded-triangle text-xs flex items-center justify-center"
              >
              </span>
            </div>
          </app-styled-options-list>
          <div class="separator-line"></div>
          <app-upload-window
            #uploadWindowComponent
            [disabled]="!currentFolder?.permissions?.[PERMISSION_LITERALS.CAN_MODIFY_CONTENT]"
            (chosenFiles)="registerFileUpload($event)"
            [allowMultipleFiles]="true"
          >
            <div
              appTooltip="Upload File or Document"
              tooltipPosition="bottom"
              [ngClass]="{
                'disabled text-navy-500': !currentFolder?.permissions?.[PERMISSION_LITERALS.CAN_MODIFY_CONTENT],
              }"
              (click)="uploadWindowComponent.openWindow()"
              class="cursor-pointer justify-center text-blue-700 btn icon icon-folded-file-upload"
            ></div>
          </app-upload-window>
          <div class="separator-line"></div>
          @if (selectedFolder | async) {
            <div class="path">
              @if (!isProjectView) {
                <span (click)="goBack(-1)" class="pointer-cursor folder-name sh-drive-root"> SH Drive </span>
              }
              @for (path of driveService.folderPath; track path; let i = $index) {
                <span (click)="goBack(i)" class="pointer-cursor folder-name">
                  @if (i > 0 || !isProjectView) {
                    <span class="icon-rounded-triangle folder-arrow"></span>
                  }
                  <app-faded-text [displayGrid]="true" class="folder-title">
                    {{ path.name }}
                  </app-faded-text>
                </span>
              }
            </div>
          }
          <!--        todo: add when backend is ready with modified grid-template-columns-->
          <!--        <div class="simple-button">-->
          <!--          <span>Archive</span>-->
          <!--          <span class="icon-folder-x"></span>-->
          <!--        </div>-->
        </div>
      }

      @if (selectedView.value === DRIVE_VIEWS.DEFAULT) {
        <div class="content">
          <div class="table-header">
            <div class="column">Folder / File name</div>
            <div class="column"></div>
            <div class="column">Type</div>
            @if (isPublicLinkAccessed) {
              <div class="column">Last Modified</div>
            }
            <div class="column">Content</div>
            <div class="column">Size</div>
            @if (!isPublicLinkAccessed) {
              <div class="column">Shared</div>
            }
            @if (!isPublicLinkAccessed) {
              <div class="column">Owner</div>
            }
            <!--        empty options column-->
          </div>
          <ng-scrollbar
            class="std-scrollbar vertical-scrollbar rows-wrapper"
            appearance="compact"
            orientation="vertical"
          >
            @if (selectedFolder | async; as folder) {
              <div class="project-segment" (contextmenu)="$event.preventDefault()">
                <!--            todo: row code may be extracted to componeent + getArray needs to be sepparated because of ordering-->
                <!--            <div (click)="goBack()" *ngIf="!folder.is_drive" class="row">-->
                <!--              <div class="column checkbox">-->
                <!--              </div>-->
                <!--              ...-->
                <!--            </div>-->
                @for (
                  item of getArray(folder.children, folder.files);
                  track item;
                  let count = $count;
                  let index = $index
                ) {
                  <div>
                    <div class="row" (contextmenu)="selectOneDocument(item, $event)">
                      <div class="column checkbox">
                        <app-checkbox
                          #documentsCheckboxes
                          (onChange)="selectFile(item)"
                          [value]="item.id"
                          [binary]="false"
                          [(ngModel)]="_selectedFilesId"
                          [inputId]="item.id | number"
                          type="square"
                        ></app-checkbox>
                      </div>
                      @if (currentFolder.is_drive && item.permissions | permissionToText) {
                        <div
                          class="column no-border transparent-background pointer-cursor flex-col"
                          (click)="openDocument(item)"
                        >
                          <input
                            disabled
                            class="no-border transparent-background pointer-cursor file-name-input"
                            (focusin)="fileFocusHandler('focusin', item)"
                            (focusout)="fileFocusHandler('focusout', item)"
                            (change)="fileFocusHandler('change', item)"
                            [ngClass]="{
                              'folder-title': driveService.isFolder(item),
                              selected: documentsCheckboxes.modelValue,
                            }"
                            [value]="driveService.isFolder(item) ? item.name : item.name.replace(regexExtension, '')"
                            [name]="'docInput_' + item.id"
                            #fileNameInput
                          />
                          <app-faded-text class="font-normal text-sm text-navy-700 italic pr-0.5 w-full">
                            {{ item.permissions | permissionToText }}</app-faded-text
                          >
                        </div>
                      } @else {
                        <div
                          class="doc-input column transition-none transparent-background pointer-cursor"
                          (click)="openDocument(item)"
                        >
                          <input
                            disabled
                            [name]="'docInput_' + item.id"
                            class="no-border transparent-background file-name-input"
                            (focusin)="fileFocusHandler('focusin', item)"
                            (focusout)="fileFocusHandler('focusout', item)"
                            (change)="fileFocusHandler('change', item)"
                            [ngClass]="{
                              'folder-title': driveService.isFolder(item),
                              selected: documentsCheckboxes.modelValue,
                            }"
                            [value]="driveService.isFolder(item) ? item.name : item.name.replace(regexExtension, '')"
                            #fileNameInput
                          />
                          <span (click)="$event.stopPropagation()" class="icon-approved text-blue-700"></span>
                        </div>
                      }
                      <app-styled-options-list
                        (selectedOption)="registerOption($event, item)"
                        [listItems]="item | overlayOptions: OVERLAY_TYPES.DRIVE : isPublicLinkAccessed : currentFolder"
                        [optionOverlayPositions]="optionOverlayPositions"
                      >
                        <div class="options">
                          @if (!isPublicLinkAccessed) {
                            <span class="icon-options-inverted text-[22px] text-blue-700 cursor-pointer pl-1"> </span>
                          }
                        </div>
                      </app-styled-options-list>
                      <div class="separator-line"></div>
                      <div class="column">
                        {{ getType(item) }}
                      </div>
                      @if (isPublicLinkAccessed) {
                        <div class="column">
                          @if (!item.isLocalFolder) {
                            {{ item.updated_at | datepipe: UTC_DATE }}
                          }
                        </div>
                      }
                      <div class="column">
                        @if (driveService.isFolder(item)) {
                          <div>
                            {{ item.files_count + item.folders_count }}
                            Files
                          </div>
                        }
                      </div>
                      <div [ngClass]="{ invisible: driveService.isFolder(item) }" class="column">
                        {{ item.size | bytes }}
                      </div>
                      @if (!isPublicLinkAccessed) {
                        <div class="column shared-col">
                          @if (item?.shared_with?.length || item.bundle_links?.length || item?.direct_link) {
                            <span> Yes </span>
                          }
                          @if (item?.shared_with?.length + item.bundle_links?.length > 1) {
                            <span> ({{ (item?.shared_with?.length ?? 0) + (item?.bundle_links?.length ?? 0) }}) </span>
                          }
                          @if (!item?.shared_with?.length && !item.bundle_links?.length && !item?.direct_link) {
                            <span class="empty"> No </span>
                          }
                        </div>
                      }
                      @if (!isPublicLinkAccessed) {
                        <div class="column owner-col">
                          @if (item.owner) {
                            <app-faded-text [displayGrid]="true" [ngClass]="{ empty: item.owner === 'Me' }">{{
                              item.owner
                            }}</app-faded-text>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (!currentDocuments.length && !currentFolder?.files_count && !currentFolder?.folders_count) {
              <div class="no-data pt-3">No files available</div>
            }
            <app-drive-empty-area (registerEmptyAreaOption)="registerEmptyAreaOption($event)"></app-drive-empty-area>
          </ng-scrollbar>
        </div>
      }

      @if (selectedView.value === DRIVE_VIEWS.WORD) {
        <app-document class="document-component" #doc [wordFile]="documentFileData"></app-document>
      }

      @if (selectedView.value === DRIVE_VIEWS.EXCEL) {
        <app-sheet class="document-sheet" #sheet [excelFile]="documentFileData"></app-sheet>
      }

      @if (selectedView.value !== DRIVE_VIEWS.DEFAULT) {
        <div class="button-container">
          <div class="discard-button" (click)="discardChanges()">Discard</div>
          <form [formGroup]="filenameForm" class="flex items-center gap-4">
            <app-floating-input
              placeholder="Input File Name"
              label="File Name"
              [verticalSpacing]="false"
              formControlName="fileName"
            ></app-floating-input>
            <div class="save-button" (click)="saveDocument()">Save</div>
          </form>
        </div>
      }
    </div>
  </ng-scrollbar>
</div>
